import React, { useContext, useEffect, useState } from "react";
import {
  ButtonGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ThemeContext } from "../../../context/theme/ThemeContext";

const SmallScreen = ({
  setsearchtoggle,
  setHamburger,
  hamburger,
  setToolState,
  toolState,
  openSideNav,
}) => {
  
  const { themeColor, changeTheme } = useContext(ThemeContext);
   const [dropdownOpen, setDropdownOpen] = useState(false);
  useEffect(() => {
    // Theme is now handled by CSS variables in ThemeContext
    // No need for manual DOM manipulation here
  }, [themeColor]);

  return (
    <>
      <div className="small_view_head">
        {/* <div
              className="ssearch_icn"
              onClick={() => {
                setsearchtoggle(true);
              }}
            >
              <i className="ri-search-line"></i>
            </div> */}
        {/* Theme color dropdown */}
        <ButtonGroup>
          <UncontrolledDropdown
            isOpen={dropdownOpen}
            toggle={() => setDropdownOpen((prev) => !prev)}
            className="header-item topbar-user"
          >
            <DropdownToggle
              tag="span"
              className="text"
              style={{
                marginLeft: "1rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              {/* Show icon for current theme */}
              {themeColor === "#181818" ? (
                <i className="ri-moon-fill" title="Dark Mode" />
              ) : (
                <i className="ri-sun-fill" title="Default/Light Mode" />
              )}
            </DropdownToggle>
            <DropdownMenu className="border-0">
              <DropdownItem
                onClick={() => changeTheme("")}
                style={{
                  color: "#212529",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
                active={themeColor === ""}
              >
                <i
                  className="ri-sun-fill"
                  style={{ color: themeColor === "" ? "#fff" : undefined }}
                />{" "}
                Default
              </DropdownItem>
              <DropdownItem
                onClick={() => changeTheme("#181818")}
                style={{
                  color: "#212529",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
                active={themeColor === "#181818"}
              >
                <i
                  className="ri-moon-fill"
                  style={{
                    color: themeColor === "#181818" ? "#fff" : undefined,
                  }}
                />{" "}
                Black
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </ButtonGroup>
        <div
          className="ssearch_icn tool_icon"
          onClick={() => {
            setHamburger(false);
            setToolState(!toolState);
            openSideNav("ToolMenu");
          }}
        >
          <i
            className="ri-tools-line "
            style={{ fontSize: "x-large", cursor: "pointer" }}
            title="Tools"
          ></i>
        </div>

        <div
          className={`hamburger_icn ${hamburger ? "openedMenu" : ""}`}
          onClick={() => {
            openSideNav("pageMenu");
            setHamburger(!hamburger);
          }}
        >
          <span className="toggle_bar lv_dn"></span>
        </div>
      </div>
    </>
  );
};

export default SmallScreen;
